// Clinical discipline display metadata, shared by admin/billing surfaces.
// Order is the conventional home-health listing: nursing first, then
// therapies, then aide/social work.

export const DISCIPLINE_ORDER = ['SN', 'PT', 'OT', 'ST', 'HHA', 'MSW'] as const;

export const DISCIPLINE_LABELS: Record<string, string> = {
  SN: 'Skilled Nursing',
  PT: 'Physical Therapy',
  OT: 'Occupational Therapy',
  ST: 'Speech Therapy',
  HHA: 'Home Health Aide',
  MSW: 'Medical Social Work',
};

// Sort key: known disciplines by DISCIPLINE_ORDER, unknown ones after.
export const disciplineSortIndex = (discipline: string): number => {
  const idx = DISCIPLINE_ORDER.indexOf(
    discipline as (typeof DISCIPLINE_ORDER)[number]
  );
  return idx === -1 ? DISCIPLINE_ORDER.length : idx;
};
